module.exports = __webpack_public_path__ + "static/blog-1-5-754a864d352749d4c584370ee58a7157.jpg";